import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled, css } from 'styled-components';

import { colorGuidance700, colorGuidance800, colorNeutral, colorSecondary400 } from 'src/styles/colors';
import { focus, focusDark } from 'src/styles/mixins';

import { LinkTheme } from './link-types';

export interface StyledLinkProps {
  $focusTheme?: LinkTheme;
}

const darkThemeForLink = css`
  font-weight: bold;
  color: ${colorNeutral};

  &:hover {
    color: ${colorSecondary400};
  }

  ${focusDark}
`;

const lightThemeForLink = css`
  color: ${colorGuidance700};

  &:hover {
    color: ${colorGuidance800};
  }

  ${focus}
`;

export const StyledLink = styled(Typography)<StyledLinkProps>`
  ${(props) => {
    switch (props.$focusTheme) {
      case LinkTheme.LIGHT:
        return lightThemeForLink;
      case LinkTheme.DARK:
        return darkThemeForLink;
      default:
        throw new Error(`Unsupported link theme ${props.$focusTheme}`);
    }
  }}
`;
